import React from 'react';
import ManufacturingSection from "../components/ManufacturingSection";
import { motion } from 'framer-motion';
const Manufacturing = () => {
    return (
        <main>
            <ManufacturingSection/>
            <section className="bg-gray-100 py-16 px-6 md:px-12">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-3xl md:text-5xl font-bold text-[#33367b]">
                        Điểm Mạnh Khác Biệt Của Timo
                    </h2>
                    <p className="mt-4 text-lg md:text-xl text-gray-700">
                        Chúng tôi cung cấp các loại vải thể thao cao cấp với chất lượng vượt trội, nguồn hàng ổn định và
                        dịch vụ hỗ trợ khách hàng tối ưu.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-w-6xl mx-auto">
                    <div className="bg-white p-6 shadow-lg rounded-lg text-center">
                        <h3 className="text-xl font-semibold text-[#33367b]">Giá Cả Hợp Lý</h3>
                        <p className="text-gray-600 mt-2">Ưu đãi đặc biệt cho khách sỉ, hỗ trợ cả đơn hàng nhỏ và
                            lớn.</p>
                    </div>

                    <div className="bg-white p-6 shadow-lg rounded-lg text-center">
                        <h3 className="text-xl font-semibold text-[#33367b]">Chất Liệu Vượt Trội</h3>
                        <p className="text-gray-600 mt-2">Co giãn 4 chiều, thấm hút mồ hôi, thoáng khí, bền bỉ.</p>
                    </div>

                    <div className="bg-white p-6 shadow-lg rounded-lg text-center">
                        <h3 className="text-xl font-semibold text-[#33367b]">Nguồn Hàng Ổn Định</h3>
                        <p className="text-gray-600 mt-2">Hợp tác với xưởng may lớn, đảm bảo nguồn cung liên tục.</p>
                    </div>
                </div>
            </section>
            <section className="bg-gray-100 py-16 px-6 md:px-12">
                <div className="max-w-6xl mx-auto text-center">
                    <motion.h2
                        initial={{opacity: 0, y: -20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.8}}
                        className="text-3xl md:text-5xl font-bold text-[#33367b]"
                    >
                        Dịch Vụ Gia Công & Sản Xuất
                    </motion.h2>
                    <motion.p
                        initial={{opacity: 0, y: 20}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.8, delay: 0.3}}
                        className="mt-4 text-lg md:text-xl text-gray-700"
                    >
                        Chúng tôi không chỉ cung cấp vải mà còn hỗ trợ gia công & sản xuất theo yêu cầu, đảm bảo chất
                        lượng đồng nhất và đáp ứng tối đa nhu cầu khách hàng.
                    </motion.p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-w-6xl mx-auto">
                    <motion.div
                        whileHover={{scale: 1.05}}
                        className="bg-white p-6 shadow-lg rounded-lg text-center"
                    >
                        <h3 className="text-xl font-semibold text-[#33367b]">Thiết Kế Theo Yêu Cầu</h3>
                        <p className="text-gray-600 mt-2">Đáp ứng mọi nhu cầu thiết kế từ áo thun, polo đến trang phục
                            thể thao chuyên dụng.</p>
                    </motion.div>

                    <motion.div
                        whileHover={{scale: 1.05}}
                        className="bg-white p-6 shadow-lg rounded-lg text-center"
                    >
                        <h3 className="text-xl font-semibold text-[#33367b]">Chất Lượng Đảm Bảo</h3>
                        <p className="text-gray-600 mt-2">Sử dụng công nghệ sản xuất tiên tiến, đảm bảo độ bền, thoáng
                            khí và hiệu suất cao.</p>
                    </motion.div>

                    <motion.div
                        whileHover={{scale: 1.05}}
                        className="bg-white p-6 shadow-lg rounded-lg text-center"
                    >
                        <h3 className="text-xl font-semibold text-[#33367b]">Sản Xuất Linh Hoạt</h3>
                        <p className="text-gray-600 mt-2">Hỗ trợ đơn hàng lớn & nhỏ, đảm bảo thời gian giao hàng đúng
                            hẹn.</p>
                    </motion.div>
                </div>
            </section>
        </main>

    );
};

export default Manufacturing;